import { Dispatch, useState } from "react";
import styles from "./CommonFields.module.css";
import { Banner, Checkbox, Collapsible, FormLayout, Label, LegacyCard, RadioButton, TextField } from "@shopify/polaris";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { asChoiceField, Field } from "@shopify/react-form";
import {
    Action,
    BxgyConfigInterface,
    FBTConfigInterface,
    MixMatchConfigInterface,
    ProductAddonsConfigInterface,
    StandardConfigInterface,
    VolumeConfigInterface,
} from "../Types";
import { BUNDLE_POSITIONS, BundlePositionsTypes } from "../constants";

type Props_BundleTypeSettings = {
    bundleName: string;
    bundleConfig:
        | StandardConfigInterface
        | VolumeConfigInterface
        | BxgyConfigInterface
        | MixMatchConfigInterface
        | FBTConfigInterface | ProductAddonsConfigInterface;
    dispatchBundleConfig: Dispatch<Action<any>>;
    submit: (event?: React.FormEvent) => Promise<void>;
    enable_stock_control: Field<boolean | undefined>;
    out_of_stock_text: Field<string>;
    work_only_with_widget: Field<boolean | undefined>;
    bundle_position: Field<BundlePositionsTypes>;
};

const BundleTypeSettings = ({
    bundleName,
    bundleConfig,
    dispatchBundleConfig,
    submit,
    enable_stock_control,
    out_of_stock_text,
    work_only_with_widget,
    bundle_position,
}: Props_BundleTypeSettings) => {
    const [expandBxgy, setExpandBxgy] = useState(true);

    return (
        <>
            <div className={styles.sectionTitleWrapper} onClick={() => setExpandBxgy((ps) => !ps)}>
                <div style={{ textTransform: "capitalize" }}>{bundleName} Bundle Settings</div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        transform: expandBxgy ? "rotate(90deg)" : "rotate(270deg)",
                    }}
                >
                    <MdOutlineArrowBackIosNew size={14} />
                </div>
            </div>
            <Collapsible
                open={expandBxgy}
                id="basic-collapsible"
                transition={{
                    duration: "500ms",
                    timingFunction: "ease-in-out",
                }}
                expandOnPrint
            >
                <FormLayout>
                    <LegacyCard title="">
                        <Banner tone={"warning"}>
                            <div>Changes made in the bxgy bundle settings will impact all bxgy bundles.</div>
                        </Banner>
                    </LegacyCard>
                    <div className={`${styles.formRow} ${styles.row1}`}>
                        <Checkbox
                            label={"Enable stock control"}
                            {...enable_stock_control}
                            value=""
                            checked={enable_stock_control.value}
                            onChange={(val) => {
                                dispatchBundleConfig({
                                    payload: {
                                        ...bundleConfig?.bundles_settings,
                                        enable_stock_control: val,
                                    },
                                    key: "bundles_settings",
                                });
                                enable_stock_control.onChange(val);
                            }}
                        />
                        <TextField
                            label={"Out of stock text on add to cart button"}
                            autoComplete=""
                            {...out_of_stock_text}
                            onBlur={submit}
                            onChange={(val) => {
                                dispatchBundleConfig({
                                    payload: {
                                        ...bundleConfig?.bundles_settings,
                                        out_of_stock_text: val,
                                    },
                                    key: "bundles_settings",
                                });
                                out_of_stock_text.onChange(val);
                            }}
                        />
                    </div>
                    <div className={`${styles.formRow} ${styles.row1}`}>
                        <Checkbox
                            label={"Work Only with Widget"}
                            {...work_only_with_widget}
                            value=""
                            checked={work_only_with_widget.value}
                            onChange={(val) => {
                                dispatchBundleConfig({
                                    payload: {
                                        ...bundleConfig?.bundles_settings,
                                        work_only_with_widget: val,
                                    },
                                    key: "bundles_settings",
                                });
                                work_only_with_widget.onChange(val);
                            }}
                        />
                    </div>
                    {/* <div className={`${styles.formRow} ${styles.formCol}`}>
                            <Checkbox
                                label={
                                    "List each product name in a new line for variant level bundles with a custom bundle image"
                                }
                                {...listing_variant_with_image}
                                value=""
                                checked={listing_variant_with_image.value}
                                onChange={(val) => {
                                    dispatchBundleConfig({
                                        payload: {
                                            ...bundleConfig?.bundles_settings,
                                            listing_variant_with_image: val,
                                        },
                                        key: "bundles_settings",
                                    });
                                    listing_variant_with_image.onChange(val);
                                }}
                            />
                        </div> */}
                    <div className={`${styles.formRow} ${styles.formCol}`}>
                        <div className={styles.customLabelWrapper} style={{ marginBottom: "5px" }}>
                            <Label id="bundle_product_level">
                                <>Bundle Position</>
                            </Label>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                marginTop: "-10px",
                            }}
                        >
                            <RadioButton
                                label={"Below Add-to-cart Form"}
                                id={BUNDLE_POSITIONS["BELOW-ADD_TO_CART"]}
                                name="bundle_position"
                                {...asChoiceField(bundle_position, "below-add_to_cart")}
                                onChange={(status, val) => {
                                    dispatchBundleConfig({
                                        payload: {
                                            ...bundleConfig?.bundles_settings,
                                            bundle_position: val,
                                        },
                                        key: "bundles_settings",
                                    });
                                    bundle_position.onChange(val as unknown as BundlePositionsTypes);
                                }}
                            />
                            <RadioButton
                                label={"Above Add-to-cart Form"}
                                id={BUNDLE_POSITIONS["ABOVE-ADD_TO_CART"]}
                                name="bundle_position"
                                {...asChoiceField(bundle_position, "above-add_to_cart")}
                                onChange={(status, val) => {
                                    dispatchBundleConfig({
                                        payload: {
                                            ...bundleConfig?.bundles_settings,
                                            bundle_position: val,
                                        },
                                        key: "bundles_settings",
                                    });
                                    bundle_position.onChange(val as unknown as BundlePositionsTypes);
                                }}
                            />
                        </div>
                    </div>
                </FormLayout>
            </Collapsible>
        </>
    );
};

export default BundleTypeSettings;
